module.exports = [{"code":0,"name":"否"},{"code":1,"name":"是"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/yesOrNo.json
// module id = 3n2K
// module chunks = 11